import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Card,
    ListGroup,
    CardHeader,
    ListGroupItem,
    Row,
    Col,
} from 'reactstrap';
import Layout from './Layout/Layout';
import Link from './utilitary-components/Link';
import './Home.css';
import { actionCreators } from '../store/UserStore';

const Home = (props: any) => {
    useEffect(() => {
        props.fetchUserData();
    }, []);

    return (
        <Layout>
            <div className="homepage-wrapper">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>Data Entry - Serology</CardHeader>
                            <ListGroup variant="flush">
                                <ListGroupItem>
                                    <Link
                                        href="/data-entry/serology-lab-equipment"
                                        className="item"
                                    >
                                        Serology Lab Equipment
                                    </Link>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Link
                                        href="/data-entry/seraq"
                                        className="item"
                                    >
                                        SeraQ Run Controls
                                    </Link>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardHeader>
                                Analysis &amp; Statistics - Serology
                            </CardHeader>
                            <ListGroup variant="flush">
                                <ListGroupItem>
                                    <Link
                                        href="/generate-statistics/seraq-performance-report"
                                        className="item"
                                    >
                                        SeraQ Run Control Reproducibility Reports
                                    </Link>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Link
                                        href="/generate-statistics/seraq-specificity-report"
                                        className="item"
                                    >
                                        Serologic Assay Specificity &amp; Robustness Reports
                                    </Link>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <CardHeader>Data Entry - NAT</CardHeader>
                            <ListGroup variant="flush">
                                <ListGroupItem>
                                    <Link
                                        href="/data-entry/nat-lab-equipment"
                                        className="item"
                                    >
                                        NAT Lab Equipment
                                    </Link>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Link
                                        href="/data-entry/viraq"
                                        className="item"
                                    >
                                        ViraQ Run Controls
                                    </Link>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardHeader>
                                Analysis &amp; Statistics - NAT
                            </CardHeader>
                            <ListGroup variant="flush">
                                <ListGroupItem>
                                    <Link
                                        href="/generate-statistics/viraq-performance-report"
                                        className="item"
                                    >
                                        ViraQ Run Control Reproducibility Reports
                                    </Link>
                                </ListGroupItem>
                                <ListGroupItem>
                                    <Link
                                        href="/generate-statistics/viraq-specificity-report"
                                        className="item"
                                    >
                                        NAT Assay Specificity &amp; Robustness Reports
                                    </Link>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </div>
            <div className='homepage-footer'>
                <Link
                    href="/privacy-policy"
                >
                    Privacy Policy
                </Link>
            </div>

        </Layout>
    );
};

//TODO: only Home component fetches user data,
// so refresh will not set the current customer name in the Layout component
// on other components

// must fetchUserData somewhere else, in Layout component probably
const { fetchUserData } = actionCreators;

export default connect(
    () => {
        return {};
    },
    { fetchUserData }
)(Home);
